import { useEffect, useMemo, useState } from 'react';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import { Stack } from '@mui/material';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import { useDispatch } from 'react-redux';
import { getAllProjects } from '../../../../redux/features/courseSlice';
import { useSelector } from 'react-redux';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import dayjs from 'dayjs';
import { getCourseSalesMatrix } from '../../../../redux/features/poinTrackerSlice';
import GlobalTableNoPagination from '../../../../components/CustomTableWithPagination/GlobalTableNoPagination';

export default function CourseSaleMatrixMain() {
  const [project, setProject] = useState({ id: -1, value: '' });
  const [fromDate, setFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 20,
    search: '',
    sort: { field: '', direction: '' },
    frozenColumns: ['staffName'],
    hiddenColumns: [],
  });

  const dispatch = useDispatch();

  const allProject = useSelector((state) => state.course.projects);
  const projectLoading = useSelector((state) => state.course.loading);
  const courseSaleMatrix = useSelector((state) => state.pointTracker.courseSaleMatrix.data);
  const courseSaleMatrixLoading = useSelector((state) => state.pointTracker.courseSaleMatrix.loading);

  useEffect(() => {
    if (!allProject?.length) dispatch(getAllProjects());
  }, [dispatch]);

  useEffect(() => {
    const params = {
      fromDate,
      toDate,
      projectId: project.id === -1 ? null : project?.id,
    };
    const courseSaleMatrixSignal = dispatch(getCourseSalesMatrix(params));
    return () => {
      courseSaleMatrixSignal.abort();
    };
  }, [fromDate, toDate, project, dispatch]);

  const styleString = `tbody tr:first-child {
    font-weight : 700 ;
    background : #b8ae89;
    }`;

  // dynamic row and column
  const [rows, columns] = useMemo(() => {
    const extraColumn = [
      {
        field: 'staffName',
        headerName: 'Staff Name',
        width: 300,
        toolTipGetter: true,
      },
      {
        field: 'total',
        headerName: 'Total',
        width: 180,
      },
    ];

    const dynamicColumns = (courseSaleMatrix.courses || []).map((courseValue) => ({
      field: courseValue?.id,
      headerName: courseValue?.name,
      width: 300,
    }));

    const allColumns = [...extraColumn, ...dynamicColumns];

    const allRows = (courseSaleMatrix.staffData || []).map((staffValue, i) => {
      return {
        uniqueId: i,
        staffName: staffValue?.staffName,
        total: staffValue?.total,
        ...staffValue?.courses,
      };
    });

    return [allRows, allColumns];
  }, [courseSaleMatrix]);

  return (
    <Stack gap={1}>
      <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
        <FromAndToDatePicker
          fromDate={fromDate}
          setFromDate={setFromDate}
          toDate={toDate}
          setToDate={setToDate}
          fullWidth
        />
        <GlobalSelectFieldWithoutFormikNew
          data={[{ id: -1, name: 'All' }, ...allProject]}
          keys={{
            itemId: 'id',
            itemValue: 'name',
          }}
          label={'Project'}
          disabled={projectLoading}
          sx={{ width: { xs: '100%', sm: 200 } }}
          selectedDetails={project}
          setChange={setProject}
        />
      </Stack>

      <GlobalTableNoPagination
        rowUniqueId="uniqueId"
        rows={rows}
        headers={columns}
        loading={courseSaleMatrixLoading}
        tableState={tableState}
        setTableState={setTableState}
        permanentFirstRow={{
          staffName: 'Grand Total',
          total: courseSaleMatrix?.totalOverall,
          ...courseSaleMatrix?.grandTotals,
        }}
        customeStyleString={styleString}
      />
    </Stack>
  );
}
